/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImpersonateUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;

export type ImpersonateUserMutation = {
  __typename?: 'mutation_root';
  impersonate_user?: { __typename?: 'ImpersonateUserOutput'; refreshToken: string } | null;
};

export const ImpersonateUserDocument = `
    mutation ImpersonateUser($userId: String!) {
  impersonate_user(object: {userId: $userId}) {
    refreshToken
  }
}
    ` as string & TypedDocumentNode<ImpersonateUserMutation, ImpersonateUserMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImpersonateUser: build.mutation<ImpersonateUserMutation, ImpersonateUserMutationVariables>({
      query: (variables) => ({ document: ImpersonateUserDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImpersonateUserMutation } = injectedRtkApi;
